import React from 'react';

function Slider() {
  return (
    <section className="tc-main-img-style1 header">
      <div className="main-img">
        <img
          src="/innerpages/assets/img/blog/b1.jpg"
          alt=""
          className="img-cover"
          data-speed="1.25"
        />
      </div>
      <div className="content">
        <div className="container">
          <div className="info">
            
            <h2 className="title">
              <a href="/" className="hover-orange1">
                Page Under Construction
              </a>
            </h2>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Slider;
